import { BorderColor } from "@mui/icons-material";
import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import moment from "moment";

import React, { memo } from "react";
import { MoneyFormatv2 } from "../../library/MoneyFormat";
import { useSelector } from "react-redux";
import { useThemes } from "../Theme/theme";
import { useListPlaceOfSupplyQuery } from "../../redux/apis/getCodeTranslation.api";

function GstReportTable({ tableData, gstTable }) {


  const { theme } = useThemes()

  // console.log(tableData);
  const companyDetails = useSelector(
    (state) => state.companyReducer.companyDetails
  );



  const { data: listOfStates } = useListPlaceOfSupplyQuery({ codetype: "IndiaState" })


  const calculateGST = (taxValue, GSTRate) => {
    return (taxValue * GSTRate) / 100;
  };

  function findPlaceOfSupplyLabel(placeOfSupply) {
    if (placeOfSupply && listOfStates) {
      const stateLabel = listOfStates?.find(
        (ele) => ele.statecode === parseInt(placeOfSupply)
      )?.statename;
      return stateLabel;
    }
    return ""

  }

  return (
    <>
      <Paper
        sx={{
          width: "100%",
          backgroundColor: "grey.200",
          overflow: "hidden",
          marginTop: 3,
        }}
      >
        <TableContainer>
          <Table stickyHeader aria-label="sticky table" sx={{ minWidth: 650 }}>
            <TableHead>
              <TableRow>
                <TableCell
                  sx={{
                    color: "#FFF",
                    backgroundColor: theme.palette.secondary.main,
                    textAlign: "center",
                    borderRight: 1,
                  }}
                  rowSpan={2}
                  colSpan={1}
                >
                  GSTIN/UIN no
                </TableCell>
                <TableCell
                  sx={{
                    color: "#FFF",
                    backgroundColor: theme.palette.secondary.main,
                    textAlign: "center",
                    borderRight: 1,
                  }}
                  rowSpan={2}
                  colSpan={1}
                >
                  Party Name
                </TableCell>
                <TableCell
                  sx={{
                    color: "#FFF",
                    backgroundColor: theme.palette.secondary.main,
                    textAlign: "center",
                    borderRight: 1,
                  }}
                  rowSpan={2}
                  colSpan={1}
                >
                  Transcation Type
                </TableCell>
                <TableCell
                  sx={{
                    color: "#FFF",
                    backgroundColor: theme.palette.secondary.main,
                    textAlign: "center",
                    borderRight: 1,
                  }}
                  colSpan={4}
                >
                  Invoice
                </TableCell>

                <TableCell
                  sx={{
                    color: "#FFF",
                    backgroundColor: theme.palette.secondary.main,
                    textAlign: "center",
                    borderRight: 1,
                  }}
                  colSpan={1}
                  rowSpan={2}
                >
                  Taxable value
                </TableCell>
                <TableCell
                  sx={{
                    color: "#FFF",
                    backgroundColor: theme.palette.secondary.main,
                    textAlign: "center",
                    borderRight: 1,
                  }}
                  colSpan={1}
                  rowSpan={2}
                >
                  Reverse value
                </TableCell>
                <TableCell
                  sx={{
                    color: "#FFF",
                    backgroundColor: theme.palette.secondary.main,
                    textAlign: "center",
                    borderRight: 1,
                  }}
                  colSpan={5}
                >
                  Amount
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell
                  sx={{
                    color: "#FFF",
                    backgroundColor: theme.palette.secondary.main,
                    textAlign: "center",
                    borderRight: 1,
                  }}
                >
                  No
                </TableCell>
                <TableCell
                  sx={{
                    color: "#FFF",
                    backgroundColor: theme.palette.secondary.main,
                    textAlign: "center",
                    borderRight: 1,
                  }}
                >
                  Date
                </TableCell>
                <TableCell
                  sx={{
                    color: "#FFF",
                    backgroundColor: theme.palette.secondary.main,
                    textAlign: "center",
                    borderRight: 1,
                  }}
                >
                  Value
                </TableCell>
                <TableCell
                  sx={{
                    color: "#FFF",
                    backgroundColor: theme.palette.secondary.main,
                    textAlign: "center",
                    borderRight: 1,
                  }}
                >
                  Rate
                </TableCell>
                <TableCell
                  sx={{
                    color: "#FFF",
                    backgroundColor: theme.palette.secondary.main,
                    textAlign: "center",
                    borderRight: 1,
                  }}
                >
                  Integrated Tax
                </TableCell>
                <TableCell
                  sx={{
                    color: "#FFF",
                    backgroundColor: theme.palette.secondary.main,
                    textAlign: "center",
                    borderRight: 1,
                  }}
                >
                  Central Tax
                </TableCell>
                <TableCell
                  sx={{
                    color: "#FFF",
                    backgroundColor: theme.palette.secondary.main,
                    textAlign: "center",
                    borderRight: 1,
                  }}
                >
                  state/UT Tax
                </TableCell>
                <TableCell
                  sx={{
                    color: "#FFF",
                    backgroundColor: theme.palette.secondary.main,
                    textAlign: "center",
                    borderRight: 1,
                  }}
                >
                  CESS
                </TableCell>
                <TableCell
                  sx={{
                    color: "#FFF",
                    backgroundColor: theme.palette.secondary.main,
                    textAlign: "center",
                    borderRight: 1,
                  }}
                >
                  Place of supply
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {tableData?.length > 0 ? (
                gstTable === "GSTR 1" ? (
                  tableData?.map((invoice) => {
                    const processedData = invoice?.relatedinvoicelinegst?.reduce((acc, obj, index) => {
                      const existingObj = acc.find((item) => item?.gstrate === obj?.gstrate);
                      if (existingObj) {
                        const updatedObj = { ...existingObj };
                        let value =
                          updatedObj.taxvalue +
                          invoice?.relatedinvoicelineitems[index]?.itemrate *
                            invoice?.relatedinvoicelineitems[index]?.quantity;
                    
                        updatedObj.taxvalue = Number(value?.toFixed(2));
                        updatedObj.cessamount = updatedObj.cessamount + obj?.cessamount;
                    
                        acc[acc.indexOf(existingObj)] = updatedObj;
                      } else {
                        const newObj = {
                          ...obj,
                          taxvalue:
                            invoice?.relatedinvoicelineitems[index]?.itemrate *
                            invoice?.relatedinvoicelineitems[index]?.quantity,
                          cessAmount: obj?.cessamount,
                        };
                    
                        acc.push(newObj);
                      }
                      return acc;
                    }, []);
                    



                    return processedData?.map((invoiceLineGST, idx1) => (
                      <TableRow key={idx1}>
                        <TableCell
                          sx={{ textAlign: "center", whiteSpace: "nowrap" }}
                        >
                          {
                            invoice?.relatedpartymaster[0]
                              ?.relatedpartygstdetails[0]?.gstin
                          }
                        </TableCell>
                        <TableCell
                          sx={{ textAlign: "center", whiteSpace: "nowrap" }}
                        >
                          {invoice?.relatedpartymaster[0]?.partylegalname}
                        </TableCell>
                        <TableCell
                          sx={{ textAlign: "center", whiteSpace: "nowrap" }}
                        >
                          {invoice?.paymenttype}
                        </TableCell>
                        <TableCell
                          sx={{ textAlign: "center", whiteSpace: "nowrap" }}
                        >
                          {invoice?.invoicenumber}
                        </TableCell>
                        <TableCell
                          sx={{ textAlign: "center", whiteSpace: "nowrap" }}
                        >
                          {invoice?.invoicedate &&
                            moment
                              .unix(invoice?.invoicedate)
                              .format("DD-MM-YYYY")}
                        </TableCell>
                        <TableCell
                          sx={{ textAlign: "center", whiteSpace: "nowrap" }}
                        >
                          {MoneyFormatv2(
                            invoice?.relatedinvoicelineitems?.reduce(
                              (acc, obj) => acc + obj?.netamount,
                              0
                            )
                          )}
                        </TableCell>
                        <TableCell
                          sx={{ textAlign: "center", whiteSpace: "nowrap" }}
                        >
                          {invoiceLineGST?.gstrate}
                        </TableCell>
                        <TableCell
                          sx={{ textAlign: "center", whiteSpace: "nowrap" }}
                        >
                          {MoneyFormatv2(invoiceLineGST?.taxvalue)}
                        </TableCell>
                        <TableCell
                          sx={{ textAlign: "center", whiteSpace: "nowrap" }}
                        >
                          {invoice?.relatedinvoicelineitems[0]
                            ?.relateditemmaster?.reversechargeflag === 1
                            ? "YES"
                            : "NO"}
                        </TableCell>
                        {invoice &&
                          companyDetails &&
                          invoice?.placeofsupply === companyDetails?.statecode ? (
                          <>
                            <TableCell
                              sx={{ textAlign: "center", whiteSpace: "nowrap" }}
                            >
                              0.0
                            </TableCell>
                            <TableCell
                              sx={{ textAlign: "center", whiteSpace: "nowrap" }}
                            >
                              {MoneyFormatv2(
                                calculateGST(
                                  invoiceLineGST?.taxvalue,
                                  invoiceLineGST?.gstrate
                                ) / 2
                              )}
                            </TableCell>
                            <TableCell
                              sx={{ textAlign: "center", whiteSpace: "nowrap" }}
                            >
                              {MoneyFormatv2(
                                calculateGST(
                                  invoiceLineGST?.taxvalue,
                                  invoiceLineGST?.gstrate
                                ) / 2
                              )}
                            </TableCell>
                          </>
                        ) : (
                          <>
                            <TableCell
                              sx={{ textAlign: "center", whiteSpace: "nowrap" }}
                            >
                              {" "}
                              {MoneyFormatv2(
                                calculateGST(
                                  invoiceLineGST?.taxvalue,
                                  invoiceLineGST?.gstrate
                                )
                              )}
                            </TableCell>
                            <TableCell
                              sx={{ textAlign: "center", whiteSpace: "nowrap" }}
                            >
                              0.0
                            </TableCell>
                            <TableCell
                              sx={{ textAlign: "center", whiteSpace: "nowrap" }}
                            >
                              0.0
                            </TableCell>
                          </>
                        )}

                        <TableCell
                          sx={{ textAlign: "center", whiteSpace: "nowrap" }}
                        >
                          {MoneyFormatv2(invoiceLineGST?.cessAmount)}
                        </TableCell>
                        <TableCell
                          sx={{ textAlign: "center", whiteSpace: "nowrap" }}
                        >
                          {findPlaceOfSupplyLabel(
                            invoice?.placeofsupply
                          )}
                        </TableCell>
                      </TableRow>
                    ));
                  })
                ) : (
                  tableData.map((purchase) => {
                    const processedData = purchase?.relatedpurchaselinegst?.reduce(
                      (acc, obj, index) => {
                        const existingObj = acc.find((item) => item?.gstrate === obj?.gstrate);
                    
                        if (existingObj) {
                          const updatedObj = { ...existingObj };
                    
                          let value =
                            updatedObj.taxvalue +
                            purchase?.relatedpurchaselineitems[index]?.itemrate *
                              purchase?.relatedpurchaselineitems[index]?.itemquantity;
                    
                          updatedObj.taxvalue = Number(value.toFixed(2));
                          updatedObj.cessamount = updatedObj.cessamount + obj.cessamount;
                    
                          acc[acc.indexOf(existingObj)] = updatedObj;
                        } else {
                          const newObj = {
                            ...obj,
                            taxvalue:
                              purchase?.relatedpurchaselineitems[index]?.itemrate *
                              purchase?.relatedpurchaselineitems[index]?.itemquantity,
                            cessAmount: obj?.cessamount, 
                          };
                    
                          acc.push(newObj);
                        }
                    
                        return acc;
                      },
                      []
                    );                    
                    return processedData?.map((purchaseLineGST, idx1) => (
                      <TableRow key={idx1}>
                        <TableCell sx={{ textAlign: "center" }}>
                          {
                            purchase?.relatedpartymaster[0]
                              ?.relatedpartygstdetails[0]?.gstin
                          }
                        </TableCell>
                        <TableCell sx={{ textAlign: "center" }}>
                          {purchase?.relatedpartymaster[0]?.partylegalname}
                        </TableCell>
                        <TableCell sx={{ textAlign: "center" }}>
                          {purchase.paymenttypecd}
                        </TableCell>
                        <TableCell sx={{ textAlign: "center" }}>
                          {purchase?.supplierinvoicenumber}
                        </TableCell>
                        <TableCell
                          sx={{ textAlign: "center", whiteSpace: "nowrap" }}
                        >
                          {purchase?.entrydate &&
                            moment
                              .unix(purchase?.entrydate)
                              .format("DD-MM-YYYY")}
                        </TableCell>
                        <TableCell sx={{ textAlign: "center" }}>
                          {purchase?.relatedpurchaselineitems?.reduce(
                            (acc, obj) => acc + obj?.netamount,
                            0
                          )}
                        </TableCell>
                        <TableCell sx={{ textAlign: "center" }}>
                          {purchaseLineGST?.gstrate}
                        </TableCell>
                        <TableCell sx={{ textAlign: "center" }}>
                          {MoneyFormatv2(purchaseLineGST?.taxvalue)}
                        </TableCell>
                        <TableCell sx={{ textAlign: "center" }}>
                          {purchase?.relatedpurchaselineitems[0]
                            ?.relateditemmaster?.reversechargeflag === 1
                            ? "YES"
                            : "NO"}
                        </TableCell>
                        {purchase &&
                          companyDetails &&
                          purchase?.placeofsupply ===
                          companyDetails?.statecode ? (
                          <>
                            <TableCell
                              sx={{ textAlign: "center", whiteSpace: "nowrap" }}
                            >
                              0.0
                            </TableCell>
                            <TableCell
                              sx={{ textAlign: "center", whiteSpace: "nowrap" }}
                            >
                              {MoneyFormatv2(
                                calculateGST(
                                  purchaseLineGST?.taxvalue,
                                  purchaseLineGST?.gstrate
                                ) / 2
                              )}
                            </TableCell>
                            <TableCell
                              sx={{ textAlign: "center", whiteSpace: "nowrap" }}
                            >
                              {MoneyFormatv2(
                                calculateGST(
                                  purchaseLineGST?.taxvalue,
                                  purchaseLineGST?.gstrate
                                ) / 2
                              )}
                            </TableCell>
                          </>
                        ) : (
                          <>
                            <TableCell
                              sx={{ textAlign: "center", whiteSpace: "nowrap" }}
                            >
                              {MoneyFormatv2(
                                calculateGST(
                                  purchaseLineGST?.taxvalue,
                                  purchaseLineGST?.gstrate
                                )
                              )}
                            </TableCell>
                            <TableCell
                              sx={{ textAlign: "center", whiteSpace: "nowrap" }}
                            >
                              0.0
                            </TableCell>
                            <TableCell
                              sx={{ textAlign: "center", whiteSpace: "nowrap" }}
                            >
                              0.0
                            </TableCell>
                          </>
                        )}
                        <TableCell sx={{ textAlign: "center" }}>
                          {MoneyFormatv2(purchaseLineGST?.cessamount)}
                        </TableCell>
                        <TableCell sx={{ textAlign: "center" }}>
                          {findPlaceOfSupplyLabel(purchase?.placeofsupply)}
                        </TableCell>
                      </TableRow>
                    ));
                  })
                )
              ) : (
                <TableRow>
                  <TableCell
                    align="center"
                    colSpan={14}
                    sx={{
                      color: "#818694",
                      fontFamily: "overpass",
                      fontSize: 15,
                      fontWeight: "bold",
                    }}
                  >
                    {`No  Reports found`}
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>
      </Paper>
    </>
  );
}

export default memo(GstReportTable);
